import { X } from 'lucide-react';
import { cx } from '../lib/cx';
import { dismissToast, useToasts } from '../lib/toast';
import { StatusDot } from './StatusDot';

/** Short results of actions and any errors, read out by screen readers. */
export function Toaster({ placement = 'bottom' }: { placement?: 'bottom' | 'above-tabs' }) {
  const toasts = useToasts();
  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      className={cx(
        'pointer-events-none fixed inset-x-0 z-50 flex flex-col items-center gap-2 px-4',
        placement === 'bottom' ? 'bottom-5' : 'bottom-[72px]',
      )}
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          role={t.tone === 'error' ? 'alert' : 'status'}
          className={cx(
            'pointer-events-auto flex max-w-[520px] animate-rise-in items-center gap-2.5 rounded-[14px] py-2 pl-4 pr-1.5 text-body leading-snug shadow-raised',
            t.tone === 'ok' ? 'bg-deep text-white' : 'border-[1.5px] border-coral bg-white text-deep',
          )}
        >
          <StatusDot dot={t.tone === 'ok' ? 'teal' : 'coral'} size={8} />
          <span className="min-w-0 flex-1">{t.text}</span>
          <button
            type="button"
            aria-label="Dismiss"
            onClick={() => dismissToast(t.id)}
            className={cx('flex size-8 shrink-0 items-center justify-center rounded-full', t.tone === 'ok' ? 'text-rail hover:bg-deep-light' : 'text-muted hover:bg-sand')}
          >
            <X size={16} strokeWidth={2.2} />
          </button>
        </div>
      ))}
    </div>
  );
}
